import { createContext, useContext } from 'react';

import type { OddsShown, OverrideBookie } from '../types';
import { oddsShownType } from '../types';

export type OddsGridContextType = {
  isTabletOrDesktop: boolean;
  oddsShown: OddsShown;
  overrideBookies?: OverrideBookie[];
};

export const OddsGridContext = createContext<OddsGridContextType>({
  isTabletOrDesktop: true,
  oddsShown: oddsShownType.BOOKMAKER_CLICKABLE,
  overrideBookies: [],
});

export const useOddsGridContext = () => useContext(OddsGridContext);
